import { HTMLAttributes } from 'react'

import Container from '@/components/base/Container'
import Form from '@/components/base/Form'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography from '@/components/base/Typography'
import Spacer from '@/components/sections/Spacer'

import { simpleAnimation } from './animations'

export type ContactFormProps = HTMLAttributes<HTMLElement> &
  Partial<{
    theme?: 'dark' | 'light'
    className: string
    title: string
    form_id: string
    form: {
      submit: string
      fields: any[]
    }
  }>

const ContactForm = ({
  className,
  title,
  form_id,
  form,
  theme,
  ...props
}: ContactFormProps) => {
  return (
    <Motion animation={simpleAnimation}>
      {(motionRef) => (
        <section ref={motionRef} className={className} {...props}>
          <Container data-motion-block>
            <Grid>
              <div className="col-span-4 md:col-span-6 lg:col-span-10 lg:col-start-2">
                <Typography variant="h2" component="h4" className="">
                  {title}
                </Typography>
              </div>
            </Grid>
            <Spacer variant="xs" theme={theme} />
            <Grid>
              <div className="col-span-4 md:col-span-6 lg:col-span-10 lg:col-start-2">
                <Form
                  form_id={form_id}
                  fields={form?.fields}
                  submit={form?.submit}
                />
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default ContactForm
